import React from 'react';

import * as styles from './SockSticker.styles';

export interface SockStickerProps {
  content: string;
}

export const SockSticker = ({ content }: SockStickerProps) => {
  return (
    <div css={styles.container}>
      <img
        src="https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/bltca5322621a5d8a63/yellow_sock.png"
        alt={content}
      />
    </div>
  );
};
